import { render } from "./FullTrainingView.vue?vue&type=template&id=0e0c4f14"
import script from "./FullTrainingView.vue?vue&type=script&lang=js"
export * from "./FullTrainingView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__